import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveUnavailability } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function UnavailabilityRemoval({ cancel, unavailability }: Props) {
  const { t } = useTranslation();
  const { removeUnavailability, isRequestPending } =
    useRemoveUnavailability(unavailability);

  return (
    <Modal
      className={styles.planzoneResourceRemoval}
      headerClassName={styles.header}
      header={t("unavailabilityRemoval.title")}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("unavailabilityRemoval.description")}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("unavailabilityRemoval.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeUnavailability(unavailability)}
          >
            {t("unavailabilityRemoval.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { UnavailabilityRemoval };
